export const lang: any = {
  get: (string: string, parameters: string[]) => {
    switch (string) {
      case 'MAX_ORDER_QUANTITY_REACHED_SUMMARY':
        return `Maximal beställningsmängd uppnådd.`;
      case 'MAX_ORDER_QUANTITY_REACHED_DETAILS':
        return `Du kan inte beställa mer än ${parameters && parameters.length > 0 ? parameters[0] : ''
          } enheter av denna produkt.`;
      case 'YOU_CAN_ADD_MORE':
        return `Du kan lägga till ${parameters[0]} till`;
      case 'QUANTITY_EXCEEDS_STOCK':
        return `Antalet överstiger tillgängligt lager. Endast ${parameters && parameters.length > 0 ? parameters[0] : '0'} tillgängliga.`;
      case 'ORDER_BEFORE_CUTOFF_AND_KITCHEN_PREPARES':
        return `Beställ före ${parameters && parameters.length > 0 ? parameters[0] : ''} för tidigare leverans`;
      case 'ADDON_SHOW_MORE_COUNT':
        return `Visa ${parameters?.[0] ?? ''} till`;
      case 'ADDON_SHOW_MORE_GROUPS_ONE':
        return `Visa ${parameters?.[0] ?? ''} grupp till`;
      case 'ADDON_SHOW_MORE_GROUPS_MANY':
        return `Visa ${parameters?.[0] ?? ''} grupper till`;
      case 'FIRST_AVAILABLE':
        return `Tidigast tillgänglig ${parameters && parameters.length > 0 ? parameters[0] : ''}`;
      case 'TODO_TODO':
        return `TODO`;
      default:
        return '';
    }
  },
  CORPORATE_CATERING: 'Företagscatering',
  GO_TO_CHECKOUT: 'Gå till kassan',
  FIRST_AVAILABLE: 'Tidigast tillgänglig',
  SELECT_PICKUP_DATE: 'Välj upphämtningsdatum',
  MAX_ORDER_QUANTITY_REACHED_SUMMARY: 'Maximal beställningsmängd uppnådd.',
  MAX_ORDER_QUANTITY_REACHED_DETAILS: 'Du kan inte beställa mer än tillåtet antal enheter av denna produkt.',
  ADD_TO_CART: 'Lägg i varugkorg',
  MORE_INFO: 'Mer information',
  COMPLETE_YOUR_ORDER: 'Slutför din beställning',
  CHECKOUT_SUBTITLE: 'Följ stegen nedan för att slutföra ditt köp',
  PICKUP_INSTRUCTIONS_LABEL: 'Upphämtningsinstruktioner',
  DELIVERY: 'Leverans',
  INFORMATION: 'Information',
  SUMMARY: 'Sammanfattning',
  PAYMENT: 'Betalning',
  DELIVERY_DETAILS: 'Leveransdetaljer',
  CHOOSE_DELIVERY_METHOD_AND_TIME: 'Välj leveransmetod, datum och tid',
  SELECTED_DELIVERY_METHOD: 'Vald leveransmetod',
  PICKUP: 'Uppämtning',
  COLLECT_FROM_LOCATION: 'Hämta på plats',
  DELIVER_TO_ADDRESS: 'Leverans till din plats',
  DELIVERY_LOCATION: 'Leveransadress',
  DELIVERY_LOCATION_PROMPT: 'Var ska vi leverera din beställning?',
  CONNECTED_COMPANY: 'Anslutet företag',
  LOCATIONS_NAME: 'Platsnamn',
  STREET_ADDRESS: 'Gatuadress',
  CITY: 'Stad',
  POSTAL_CODE: 'Postnummer',
  FLOOR: 'Våning',
  DELIVERY_ROOM: 'Leveransrum',
  DOOR_CODE: 'Portkod',
  DATE_AND_TIME: 'Datum och tid',
  PICKUP_DATE_AND_TIME: 'Upphämtningsdatum och tid',
  DELIVERY_DATE_AND_TIME: 'Leveransdatum och tid',
  SELECT_DATE: 'Välj datum',
  SELECT_TIME: 'Välj tid',
  ADDITIONAL_INSTRUCTIONS: 'Ytterligare instruktioner',
  COMMENT_TO_RESTAURANT: 'Kommentar till restaurangen',
  COMMENT_TO_RESTAURANT_PLACEHOLDER:
    'Har du något du vill informera om?',
  CONTINUE_TO_INFORMATION: 'Fortsätt till din information',
  CONTINUE: 'Fortsätt',
  CONTINUE_CHECKOUT: 'Fortsätt med köpet',
  YOUR_INFORMATION: 'Din information',
  CONTACT_BILLING_DETAILS: 'Kontakt och faktureringsuppgifter',
  CONTACT_INFO: 'Kontaktinformation',
  CONTACT_INFO_DESCRIPTION:
    'Vi kommer att använda denna information för att kontakta dig om din beställning.',
  FIRST_NAME: 'Förnamn',
  FIRST_NAME_REQUIRED: 'Förnamn krävs.',
  LAST_NAME: 'Efternamn',
  EMAIL_ADDRESS: 'E-postadress',
  PHONE_NUMBER: 'Telefonnummer',
  ADDITIONAL_INFORMATION: 'Ytterligare information',
  BACK: 'Tillbaka',
  PREVIOUS: 'Föregående',
  CONTINUE_TO_SUMMARY: 'Fortsätt till sammanfattning',
  ORDER_SUMMARY: 'Beställningssammanfattning',
  ORDER_SUMMARY_SUBTOTAL: 'Granska dina beställningsdetaljer',
  YOUR_ITEMS: 'Dina varor',
  YOUR_ORDER: 'Din beställning',
  CLOSE: 'Stäng',
  TOTAL_AMOUNT: 'Totalt belopp',
  DELIVERY_INFORMATION: 'Leveransinformation',
  DELIVERY_METHOD: 'Leveransmetod',
  NAME: 'Namn',
  CREATED: 'Skapad',
  EMAIL: 'E-post',
  USER_ID: 'Användar-ID',
  PHONE: 'Telefon',
  ADDRESS: 'Adress',
  RESTAURANT_INFO: 'Restauranginformation',
  COMPANY_NAME: 'Företagsnamn',
  PROCEED_TO_PAYMENT: 'Fortsätt till betalning',
  PAYMENT_METHOD: 'Betalningsmetod',
  SELECT_PAYMENT_METHOD: 'Välj betalningsmetod',
  PAYMENT_METHOD_DESCRIPTION: 'Välj ditt föredragna betalningsalternativ',
  CREDIT_CARD: 'Kreditkort',
  CREDIT_CARD_DESCRIPTION: 'Betala säkert med kort',
  INVOICE: 'Faktura',
  INVOICE_DESCRIPTION: 'Betala senare via faktura',
  CASH: 'Kontant',
  CASH_DESCRIPTION: 'Betala vid leverans/hämtning',
  CONFIRM_ORDER: 'Bekräfta betalning',
  ORDER_PLACED: 'Beställning placerad!',
  SUCCESS_TEXT_1:
    'Din beställning har placerats framgångsrikt. Vi skickar dig en bekräftelse via e-post snart.',
  SUCCESS_TEXT_2:
    'Efter att ha slutfört betalningscheckout-sessionen kommer du att få ett beställningsbekräftelsemail. Kontrollera din e-post för framtida beställningsuppdateringar.',
  PAYMENT_REQUIRED: 'Betalning krävs',
  INCOMPLETE_ORDER: 'Ofullständig beställning',
  KEEP_SHOPPING: 'Fortsätt handla',
  CANCEL_CHECKOUT_PROMPT: 'Är du säker på att du vill avbryta checkout?',
  CONFIRMATION: 'Bekräftelse',
  CANCEL: 'Avbryt',
  YES: 'Ja',
  TOTAL_PRICE_IS_0: 'Totalpris är 0',
  PLEASE_ADD_ITEMS_TO_CART: 'Lägg till produkter i kundvagnen',
  ITEM: 'Vara',
  ITEMS: 'Varor',
  EMPTY_CART: 'Din kundvagn är tom',
  ADD_SOME_ITEMS: 'Lägg till några varor för att komma igång!',
  SHOPPING_CART: 'Kundvagn',
  CLEAR_CART: 'Rensa kundvagn',
  CLOSE_CART: 'Stäng varukorg',
  CLEAR_CART_WARNING: 'Är du säker på att du vill tömma din kundvagn?',
  CLEAR_CART_YES: 'Töm kundvagnen',
  CLEAR_CART_NO: 'Töm inte kundvagnen',
  CART_ITEMS_NOT_AVAILABLE_FOR_SELECTED_DATE: 'Vissa varor i kundvagnen är inte tillgängliga för det valda leveransdatumet. Du kan ta bort dem eller fortsätta.',
  NOT_AVAILABLE_FOR_DATE: 'Ej tillgänglig på valt datum',
  CLEAR: 'Rensa',
  SUBTOTAL: 'Delsumma',
  TOTAL_ITEMS: 'Totalt antal varor',
  TOTAL: 'Totalt',
  VAT: 'varav moms',
  CHECKOUT: 'Till kassan',
  CONTACT: 'Kontakt',
  LOCATION: 'Plats',
  Mobile_Pay_DESCRIPTION: 'Betala säkert med mobilbetalning',
  Mobile_Pay: 'MobilePay',
  CONTINUE_SHOPPING: 'Fortsätt handla',
  QUANTITY: 'Antal',
  LANGUAGE: 'Språk',
  SELECT_LANGUAGE: 'Välj språk',
  CURRENT: 'Aktuell',
  NO_LANGUAGES_FOUND: 'Inga språk hittades',
  TRY_DIFFERENT_SEARCH: 'Prova en annan sökterm',
  CHOOSE_A_DATE: 'Välj ett datum',
  CHOOSE_A_TIME: 'Välj en tid',
  SELECT_PICKUP_TIME: 'Välj upphämtningstid',
  COMPANY_NAME_OPTIONAL: 'Företagsnamn (valfritt)',
  LOCATION_NAME_OPTIONAL: 'Platsnamn (valfritt)',
  ENTER_STREET_ADDRESS: 'Ange gatuadress',
  ENTER_CITY: 'Ange stad',
  ENTER_POSTAL_CODE: 'Ange postnummer',
  FLOOR_NUMBER_OPTIONAL: 'Våningsnummer (valfritt)',
  ROOM_NUMBER_OPTIONAL: 'Rumsnummer (valfritt)',
  ACCESS_CODE_OPTIONAL: 'Åtkomstkod (valfritt)',
  ENTER_FIRST_NAME: 'Ange ditt förnamn',
  ENTER_LAST_NAME: 'Ange ditt efternamn',
  ENTER_EMAIL: 'Ange din e-postadress',
  ENTER_ADDRESS: 'Ange din adress',
  EMAIL_REQUIRED: 'E-postadress krävs.',
  EMAIL_INVALID: 'Ange en giltig e-postadress.',
  SUCCESS: 'Lyckat',
  ERROR: 'Fel',
  SAVING: 'Sparar…',
  SET_PASSWORD_TITLE: 'Sätt ditt lösenord',
  SET_PASSWORD_FOR_ACCOUNT: 'För konto:',
  SET_PASSWORD_SUBTITLE: 'Ange ett nytt lösenord för ditt konto.',
  NEW_PASSWORD: 'Nytt lösenord',
  CONFIRM_NEW_PASSWORD: 'Bekräfta nytt lösenord',
  SAVE_PASSWORD: 'Spara lösenord',
  PROCESSING_LINK: 'Bearbetar länk…',
  RESET_LINK_INVALID: 'Länken för återställning av lösenord är ogiltig eller har gått ut.',
  FILL_BOTH_PASSWORD_FIELDS: 'Fyll i båda lösenordsfälten.',
  PASSWORDS_DO_NOT_MATCH: 'Lösenorden matchar inte.',
  PASSWORD_TOO_SHORT: 'Lösenordet måste vara minst 6 tecken.',
  PASSWORD_RESET_SUCCESS: 'Lösenordet har återställts.',
  PASSWORD_RESET_FAILED: 'Kunde inte återställa lösenord. Försök igen.',
  LOGIN_SUCCESS: 'Du är nu inloggad.',
  DELIVERY_OPTIONS_UNLOCKED: 'Leveransalternativ är nu tillgängliga.',
  LOGIN_INVALID_CREDENTIALS: 'Ogiltig e-post eller lösenord.',
  AUTH_EMAIL_MISSING_AT: "Vänligen inkludera ett '@' i din e-postadress.",
  LOGIN_FAILED: 'Inloggningen misslyckades. Försök igen.',
  ACCOUNT_CREATED_SUCCESS: 'Kontot skapades.',
  ACCOUNT_CREATED_FAILED: 'Kunde inte skapa konto.',
  ACCOUNT_ALREADY_EXISTS_ON_THIS_MAIL: 'Kontot finns redan på denna e-post.',
  OKAY: 'Okej',
  ADD_TO_CART_HEADER: 'Lägg till i kundvagn',
  PER_UNIT: 'per enhet',
  QUANTITY_LABEL: 'Antal (min. {{min}})',
  MIN_ORDER_QUANTITY: 'Minsta beställningsmängd',
  MAX_ORDER_QUANTITY: 'Max beställningsmängd',
  UNITS: 'stycken',
  PICKUP_TIME: 'Upphämtningstid',
  DELIVERY_TIME: 'Leveranstid',
  DELIVERY_DATE: 'Leveransdatum',
  PICKUP_DATE: 'Upphämtningsdatum',
  ORDER_TYPE: 'Beställningstyp',
  HOME_DATE_SELECTION_UNAVAILABLE_TITLE: 'Inga serveringssätt tillgängliga',
  HOME_DATE_SELECTION_UNAVAILABLE_DESCRIPTION: 'Denna restaurang tar för närvarande inte emot beställningar för hämtning eller leverans.',
  HOME_DATE_SELECTION_UNAVAILABLE_NOTE: 'Tar inte emot beställningar just nu',
  SELECT_DELIVERY_DATE: 'Välj leveransdatum',
  SELECT_DELIVERY_AND_DATE: 'Leverans och datum',
  SELECT_ORDER_DATE: 'Leveranssätt och datum',
  CONTINUE_WITHOUT_DATE: 'Fortsätt utan datum',
  SELECT_WEEKDAY: 'Välj mellan upphämtning eller företagsleverans och ange önskat datum',
  JUST_BROWSING: 'Bara tittar',
  CONFIRM: 'Bekräfta',
  PRICE: 'Pris',
  PRODUCT_DESCRIPTION: 'Produktbeskrivning',
  READ_MORE: 'Läs mer',
  READ_LESS: 'Läs mindre',
  SERVINGS_PER_PRODUCT: 'Portioner per produkt',
  RETURN_TO_HOME: 'Återgå till startsidan',
  ORDER_FAILED: 'Beställningen misslyckades',
  MAXIMUM_ORDER_QUANTITY: 'Maximum',
  MINIMUM_ORDER_QUANTITY: 'Minimum',
  LOCATION_FOOTER: 'Adress',
  INFO_FOOTER: 'Mer information',
  HOSTED_BY_PUBQ: 'Hostas av PubQ AB',
  TERMS_OF_SERVICE: 'Användarvillkor',
  NO_PRODUCTS_AVAILABLE: 'Inga produkter tillgängliga',
  CHECK_BACK_SOON_CATEGORY:
    'Kom tillbaka snart för nya produkter i denna kategori',
  NO_CATEGORIES_AVAILABLE: 'Inga kategorier tillgängliga',
  CHECK_BACK_LATER: 'Kom tillbaka senare för uppdateringar!',
  NO_MENU_AVAILABLE: 'Ingen meny tillgänglig',
  MENU_UPDATING_MESSAGE:
    'Vi uppdaterar just nu vår meny. Kom tillbaka snart för våra läckra erbjudanden!',
  REFRESH_PAGE: 'Uppdatera sidan',
  CONTACT_US: 'Kontakta oss',
  READ_TERMS: 'Jag har läst användarvillkoren',
  ACCEPT_PURCHASE_TERMS_PREFIX: 'Genom att slutföra detta köp accepterar du våra ',
  TERMS_AND_CONDITIONS: 'Allmänna villkor',
  ACCEPT_PURCHASE_TERMS_AND: ' och ',
  PRIVACY_POLICY: 'Integritetspolicy',
  NO_PRODUCTS_IN_CATEGORY: 'Inga produkter i denna kategori',
  NO_PRODUCTS_MATCH_FILTERS: 'Inga produkter matchar dina valda filter.',
  PRODUCTS_COMING_SOON: 'Produkter kommer snart!',
  TIME_SLOT_NOT_SELECTED: 'Tidslucka har inte valts',
  SEE_MORE: 'Se mer',
  SOON_BACK_IN_STOCK: 'Tillbaka i lager snart',
  FEW_LEFT_IN_STOCK: 'Få kvar i lager',
  OUT_OF_STOCK: 'Slutsåld',
  QUANTITY_EXCEEDS_STOCK: 'Antalet överstiger tillgängligt lager. Endast {{0}} tillgängliga.',
  INACTIVE: 'Inaktiv',
  CURRENTLY_UNAVAILABLE: 'För närvarande inte tillgänglig',
  PREPARATION_DAYS_REQUIRED: 'Förberedelsedagar krävs',
  DAYS: 'Dagar',
  AVAILABLE: 'Tillgänglig',
  AVAILABLE_PICKUP_DATES: 'Tillgängliga upphämtningstider',
  CONTENTS_AND_ALLERGENS: 'Innehåll och allergier',
  SIMILAR_PRODUCTS: 'Liknande produkter',
  MILK: '🥛 Mjölk',
  MILK_PROTEIN: '🥛 Mjölkprotein',
  GLUTEN: '🌾 Gluten',
  NUTS: '🥜 Nötter',
  CRUSTACEANS: '🦞 Kräftdjur',
  EGG: '🥚 Ägg',
  MOLLUSCS: '🦪 Blötdjur',
  FISH: '🐟 Fisk',
  PORK: '🥓 Fläskkött',
  PEANUTS: '🥜 Jordnötter',
  SESAME_SEEDS: 'Sesamfrön',
  SULPHUR: 'Svaveldioxid och sulfiter',
  SOYBEANS: '🫘 Sojabönor',
  CELERY: '🥬 Selleri',
  MUSTARD: 'Senap',
  LUPIN: 'Lupin',
  GARLIC: '🧄 Vitlök',
  MUSHROOM: '🍄‍🟫 Svamp',
  ALMOND: '🥜 Mandel',
  HAZELNUT: '🥜 Hasselnötter',
  WALNUT: '🥜 Valnötter',
  CASHEW: '🥜 Cashewnötter',
  PECAN: '🥜 Pecannötter',
  BRAZIL_NUT: '🥜 Paranötter',
  PISTACHIO: '🥜 Pistaschnötter',
  MACADAMIA: '🥜 Macadamianötter',
  DESCRIPTION: 'Beskrivning',
  ADDONS: 'Tillbehör',
  ADDON_PICK_ONE: 'Välj en',
  ADDON_REQUIRED: 'Obligatorisk',
  ADDON_OPTIONAL: 'Valfritt',
  ADDON_MIN: 'Min',
  ADDON_MAX: 'Max',
  ADDON_UNAVAILABLE: 'Ej tillgänglig',
  ADDON_SHOW_LESS: 'Visa färre',
  ADDON_SHOW_FEWER_GROUPS: 'Visa färre grupper',
  // Success page translations
  ORDER_CONFIRMED: 'Beställning bekräftad!',
  ORDER_NUMBER_LABEL: 'Beställning #',
  PAYMENT_PROCESSED: 'Betalning behandlad',
  PAYMENT_CONFIRMED: 'Din betalning har bekräftats',
  EMAIL_SENT: 'E-post skickad',
  EMAIL_CONFIRMATION_SENT: 'Bekräftelse skickad till din inkorg',
  ORDER_PROCESSING: 'Beställning behandlas',
  ORDER_PREPARING: 'Restaurangen förbereder din beställning',
  BACK_TO_HOME: 'Tillbaka till startsidan',
  // Failure page translations
  PAYMENT_FAILED: 'Betalning misslyckades',
  PAYMENT_DECLINED: 'Betalning avvisad',
  PAYMENT_METHOD_DECLINED: 'Din betalningsmetod avvisades',
  WHAT_TO_DO_NEXT: 'Vad ska du göra härnäst?',
  VERIFY_PAYMENT_AND_RETRY:
    'Verifiera dina betalningsuppgifter och försök igen',
  HOME: 'Hem',
  MAXIMUM_REACHED: 'Maximum uppnått',
  SEARCH_TEXT: 'Sök...',
  IMPORTANT_INFORMATION: 'Viktig information',
  DIFFERENT_PRODUCTION_TIMES_WARNING: 'Det tidigaste leveransdatumet baseras på produkten med längst produktionstid',
  GOOGLE_PAY: 'Google Pay',
  GOOGLE_PAY_DESCRIPTION: 'Betala säkert med Google Pay',
  APPLE_PAY: 'Apple Pay',
  APPLE_PAY_DESCRIPTION: 'Betala säkert med Apple Pay',
  SWISH: 'Swish',
  SWISH_DESCRIPTION: 'Betala säkert med Swish',
  COMPLETE_SWISH_PAYMENT: 'Slutför Swish-betalning',
  SELECT_WHERE_TO_OPEN_SWISH: 'Välj var du vill öppna Swish',
  LAUNCHES_SWISH_APP: 'Startar Swish-appen',
  SCAN_QR_CODE: 'Skanna QR-kod',
  CANCEL_PAYMENT: 'Avbryt betalning',
  // Swish payment component
  SWISH_CHOOSE_HOW_TO_PAY: 'Välj hur du vill betala',
  SWISH_SUBTITLE: 'Använd Swish på den här enheten eller på en annan enhet.',
  SWISH_PAY_ON_THIS_DEVICE: 'Betala på denna enhet',
  SWISH_PAY_ON_OTHER_DEVICE: 'Betala på annan enhet',
  SWISH_SCAN_QR_CODE: 'Skanna QR-koden med Swish för att betala',
  PAYMENT_DEVICE_NOT_SUPPORTED: 'Denna enhet stödjer inte Swish-betalningar',
  SWISH_OPEN_ON_PHONE: 'Öppna Swish på din telefon för att betala',
  SWISH_OPEN_APP: 'Öppna Swish',
  SWISH_PAYMENT_SUCCESS: 'Betalning lyckades',
  SWISH_PAYMENT_FAILED: 'Betalning misslyckades',
  SWISH_PAYMENT_ERROR: 'Fel vid behandling av betalning.',
  SWISH_PAYMENT_CANCELLED_INFO:
    'Betalningen avbröts i Swish. Ändra beställningen vid behov och använd sedan samma Swish-knapp igen för en ny QR-kod.',
  SWISH_VERIFY_TIMEOUT: 'Swish-betalningen tog för lång tid',
  BACK_TO_CHECKOUT: 'Tillbaka till kassan',
  EARLIEST_DELIVERY_DATE: 'Tidigast leveransdatum',
  EARLIEST_POSSIBLE_DELIVERY_DATE_IS: 'Tidigaste leveransdatum',
  AVAILABLE_FROM: 'Tillgänglig från',
  DELIVER: 'Leverans',
  DELIVERY_LOCATIONS: 'Leveransplatser',
  CORPORATE_DELIVERY_LOCATIONS: 'Leveransplatser för detta företag',
  NO_CORPORATE_CUSTOMERS: 'Inga företagskunder tillgängliga',
  COMPANY: 'Företag',
  ENTRANCE_CODE: 'Åtkomstkod',
  DEFAULT_REFERENCE: 'Standardreferens',
  SPECIFIC_LOCATION: 'Specifik plats',
  SELECT_LOCATION: 'Välj plats',
  VIEW_ALL_DELIVERY_LOCATIONS: 'Visa alla leveransplatser',
  CHANGE: 'Ändra',
  SELECT: 'Välj',
  INVOICE_INFORMATION: 'Fakturaadress',
  INVOICE_ADDRESS: 'Fakturaadress',
  ORGANIZATION_NUMBER: 'Organisationsnummer',
  VAT_NUMBER: 'Momsnummer',
  COST_CENTER: 'Kostnadsställe',
  SELECT_DELIVERY_TIME: 'Välj leveranstid',
  SELECT_DELIVERY_LOCATION: 'Välj leveransplats',
  // Login dialog
  LOGIN_TO_YOUR_ACCOUNT: 'Logga in på ditt konto',
  LOGIN_SUBTITLE: 'Logga in för att hantera dina cateringbeställningar och få tillgång till företagscatering',
  LOGIN_EMAIL_PLACEHOLDER: 'example@email.com',
  PASSWORD: 'Lösenord',
  FORGOT_PASSWORD: 'Glömt lösenord?',
  LOGIN_PASSWORD_PLACEHOLDER: 'Ange ditt lösenord',
  LOGIN: 'Logga in',
  CREATE_NEW_ACCOUNT: 'Skapa nytt konto',
  OR_CONTINUE_WITH: 'Eller fortsätt med',
  CONTINUE_WITH_GOOGLE: 'Fortsätt med Google',
  CONTINUE_WITH_MICROSOFT: 'Fortsätt med Microsoft',
  CONTINUE_WITH_APPLE: 'Fortsätt med Apple',
  CREATE_YOUR_ACCOUNT: 'Skapa ditt konto',
  CREATE_ACCOUNT_SUBTITLE: 'Registrera dig för att få åtkomst till företagets leveransalternativ',
  BACK_TO_LOGIN: 'Tillbaka till login',
  CONFIRM_PASSWORD: 'Bekräfta lösenord',
  PASSWORD_REQUIREMENTS: 'Lösenordet måste vara minst 6 tecken.',
  CREATE_ACCOUNT: 'Skapa konto',
  OR_SIGN_UP_WITH: 'Eller registrera dig med',
  BACK_TO_STORE: 'Tillbaka till butiken',
  MY_ACCOUNT: 'Mitt konto',
  MY_PAGE: 'Min sida',
  ACCOUNT_INFORMATION: 'Mina uppgifter',
  EDIT: 'Redigera',
  ADD: 'Lägg till',
  LOGOUT: 'Logga ut',
  LOGOUT_SUCCESS: 'Du har loggats ut.',
  ACTIVE_ORDERS: 'Aktiva beställningar',
  PREVIOUS_ORDERS: 'Tidigare beställningar',
  ORDER_STATUS: 'Status',
  ORDER_NUMBER: 'Beställning',
  DECLINED: 'Avvisad',
  COMPLETED: 'Klar',
  DONE: 'Klar',
  RECEIPTS: 'Kvitton',
  NO_ORDERS_YET: 'Inga beställningar ännu',
  NO_ACTIVE_ORDERS_YET: 'Inga aktiva beställningar',
  NO_ACTIVE_ORDERS_SUBTITLE: 'Beställningar du lagt kommer visas här medan de förbereds.',
  NO_PREVIOUS_ORDERS_YET: 'Inga tidigare beställningar',
  NO_PREVIOUS_ORDERS_SUBTITLE: 'Genomförda eller avvisade beställningar från senaste månaden visas här.',
  NO_RECEIPTS_YET: 'Inga kvitton ännu',
  NO_RECEIPTS_SUBTITLE: 'Kvitton för dina beställningar visas här.',
  NO_CORPORATE_COMPANY_CONNECTED: 'Inget företag kopplat',
  NO_CORPORATE_COMPANY_SUBTITLE: 'Koppla ett företagskonto för att beställa leverans till din arbetsplats.',
  WANT_DELIVERY_TO_YOUR_COMPANY: 'Vill du ha leverans till ditt företag?',
  DELIVERY_TO_COMPANY: 'Företagsleverans',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY: 'Leverans inte tillgänglig',
  DELIVERY_NOT_AVAILABLE_NO_COMPANY_DESCRIPTION: 'Du har inte tillgång till företagscatering',
  NO_SERVING_METHODS_AVAILABLE: 'Inga serveringssätt tillgängliga',
  NO_SERVING_METHODS_AVAILABLE_DESCRIPTION: 'Denna restaurang tar för närvarande inte emot beställningar för hämtning eller leverans.',
  CREATE_ACCOUNT_OR_LOGIN: 'Skapa konto eller logga in',
  ENTER_PHONE: 'Ange telefonnummer',
  CURRENT_PASSWORD: 'Nuvarande lösenord',
  ENTER_CURRENT_PASSWORD: 'Ange nuvarande lösenord',
  SAVE: 'Spara',
  // Account receipts
  CLIENT_INFORMATION: 'Kundinformation',
  VAT_ID: 'Momsregistreringsnummer',
  RECEIPT: 'Kvitto',
  RECEIPT_NUMBER: 'Kvittotnummer',
  DATE: 'Datum',
  PRODUCTS: 'Produkter',
  PRODUCT: 'Produkt',
  DISCOUNT: 'Rabatt',
  // Forgot password page
  FORGOT_PASSWORD_TITLE: 'Glömt ditt lösenord?',
  FORGOT_PASSWORD_SUBTITLE: 'Ange din e-postadress för att få en länk för återställning av lösenord.',
  FORGOT_PASSWORD_EMAIL_PLACEHOLDER: 'Ange din e-postadress',
  FORGOT_PASSWORD_SUBMIT: 'Skicka återställningslänk',
  FORGOT_PASSWORD_BACK: 'Tillbaka till inloggning',
  FORGOT_PASSWORD_EMAIL_SENT: 'En länk för att återställa lösenordet har skickats till din e-post.',
  FORGOT_PASSWORD_FAILED: 'Kunde inte skicka återställningsmail. Försök igen.',
  FORGOT_PASSWORD_INVALID_EMAIL: 'Ange en giltig e-postadress.',
  GO_BACK: 'Gå tillbaka',
  SUBMIT: 'Skicka',
  //Home-panel translations
  CATEGORIES: 'Kategorier',
  DIETARY_OPTIONS: 'Dietanpassade alternativ',
  SAVED_CARDS: 'Sparade kort',
  COMING_SOON: 'Kommer snart',
  ORDERS: 'Beställningar',
  SHOW_MORE: 'Visa mer',
  SHOW_LESS: 'Visa mindre',
  APPLY_FILTER: 'Applicera filter',
  START_DATE: 'Startdatum',
  END_DATE: 'Slutdatum',
  FILTER_RESULT: 'Filterresultat',
  TOTAL_ACTIVE_ORDERS: 'Totala aktiva beställningar',
  TOTAL_PREVIOUS_ORDERS: 'Totala tidigare beställningar',
  TOTAL_SAVED_RECEIPTS: 'Totala sparade kvitton',
  CARD_DETAILS: 'Kortinformation',
  ALL: 'Alla',
  CARD: 'Kort',
  REMOVE_CARD: 'Ta bort kort',
  REMOVE_CARD_TITLE: 'Ta bort sparat kort?',
  REMOVE_CARD_WARNING: 'Det här kortet kommer att tas bort permanent från alla PubQ-system — inklusive mobilappen, webborder och alla andra PubQ-plattformar. Åtgärden kan inte ångras.',
  REMOVE_CARD_CONFIRM: 'Ja, ta bort kort',
  REMOVE_CARD_FAILED: 'Kunde inte ta bort kortet. Försök igen.',
  REMOVING_CARD: 'Tar bort…',
  SELECT_BOTH_START_END_DATES: 'Välj både start- och slutdatum.',
  START_DATE_MUST_BE_BEFORE_END_DATE: 'Startdatum måste vara före slutdatum.',
  CATERING_PENDING: 'Väntande',
  APPROVED: 'Godkänd',
  COUPON: 'Rabatter',
  APPLY_DISCOUNT: 'Tillämpa rabatt',
  COUPON_CODE: 'Rabattkod',
  HAVE_A_COUPON_CODE: 'Har du en rabattkod?',
  USE_COUPON_CODE: 'Använd din rabattkod',
  ENTER_YOUR_CODE_BELOW: 'Ange din kod nedan',
  ENTER_YOUR_CODE_HERE: 'Ange din kod',
  APPLY: 'Använd',
  REMOVE: 'Ta bort',
  TOTAL_DISCOUNT: 'Total rabatt',
  INVALID_COUPON: 'Ogiltig kod',
  CHECKING_DISCOUNT_CODE: 'Kontrollerar kod…',
  APPLIED_DISCOUNT: 'Rabatt tillämpad',
  UNEXPECTED_ERROR: 'Ett oväntat fel uppstod.',
  UNEXPECTED_ERROR_TRY_AGAIN: 'Ett oväntat fel uppstod. Försök igen.',
  PLEASE_FILL_REQUIRED_FIELDS: 'Fyll i alla obligatoriska fält',
  EACH: 'st',
  TOTAL_ITEMS_PRODUCT_PAGE: 'Artiklar',
  ONLY_ONE_SERVING_METHOD_AVAILABLE: 'Val av datum',
  SELECT_WEEKDAY_SINGLE_METHOD: 'När vill du få din beställning?',
  POWERED_BY: 'Drivs av',
  FROM: 'Från',
  EX_VAT: 'exkl. moms',
  OF_WHICH_VAT: 'varav moms',
  VAT_AMOUNT: 'Moms',
  TOTAL_INC_VAT: 'Totalt inkl. moms',
  NO_COST: 'Ingen kostnad',

  // --- Guest "order by invoice" checkout (no login) ---
  GUEST_INVOICE_TITLE: "Beställ mot faktura",
  DELIVERY_GUEST_INVOICE: "Leverans / beställ mot faktura",
  GUEST_INVOICE_DESCRIPTION: "Inget konto behövs — vi fakturerar ditt företag",
  GUEST_INVOICE_EVENT_SECTION: "Uppgifter om tillfället",
  GUEST_INVOICE_EVENT_SECTION_DESCRIPTION: "Berätta vilket möte cateringen gäller.",
  GUEST_INVOICE_BILLING_SECTION: "Företags- och faktureringsuppgifter",
  GUEST_INVOICE_BILLING_SECTION_DESCRIPTION: "Fakturan skickas till dessa uppgifter. Ingen betalning dras nu.",
  MEETING_ROOM_NAME: "Konferensrummets namn",
  MEETING_ROOM_NAME_PLACEHOLDER: "t.ex. Konferensrum Aurora",
  NUMBER_OF_ATTENDEES: "Antal personer",
  EVENT_HOST: "Värd för tillfället",
  EVENT_END_TIME: "Tillfället slutar (valfritt)",
  SPECIAL_DIETS: "Specialkoster",
  SPECIAL_DIETS_PLACEHOLDER: "t.ex. 2 glutenfria, 1 vegan",
  PARTICIPANT_LIST: "Deltagarlista",
  PARTICIPANT_LIST_PLACEHOLDER: "Deltagarnas namn (valfritt)",
  INVOICE_REFERENCE: "Referensuppgifter",
  INVOICE_REFERENCE_PLACEHOLDER: "t.ex. projekt- eller referensnummer",
  INVOICE_EMAIL: "Fakturamejl",
  INVOICE_NO_PAYMENT_TAKEN: "Ingen betalning dragen",
  INVOICE_WILL_FOLLOW: "Ingenting har debiterats. En faktura skickas till de faktureringsuppgifter du angav.",
  ORDER_TERMS_TITLE: "Beställningsvillkor",
  ORDER_TERMS_BODY: "Beställningen är bindande. Ändringar och avbokningar ska göras senast två (2) arbetsdagar före tillfället; senare avbokningar faktureras i sin helhet. Det antal personer som bekräftats vid beställning ligger till grund för faktureringen. Betalningsvillkor 14 dagar netto.",

  // --- Partner group restaurant picker (/g/:slug) ---
  PARTNER_CHOOSE_RESTAURANT: "Välj restaurang",
  PARTNER_CHOOSE_RESTAURANT_HINT: "Välj var du vill beställa din catering ifrån.",
  PARTNER_ORDER_FROM_HERE: "Beställ",
  PARTNER_GROUP_NOT_FOUND: "Sidan hittades inte",
  PARTNER_GROUP_NOT_FOUND_DESCRIPTION: "Den här länken till restauranggruppen är inte tillgänglig. Kontrollera länken och försök igen.",
};
